import React from 'react';
import styled from 'styled-components';
import Draggable from '../Draggable';
import Droppable from '../Droppable';

const Wrapper = styled.div`
    width: 100%;
    padding: 32px;
    display: flex;
    justify-content: center;
`;

const Item = styled.div`
    padding: 8px;
    color: #555;
    background-color: white;
    border-radius: 3px;
`;

const droppableStyle = {
    backgroundColor: '#555',
    width: '250px',
    height: '400px',
    margin: '32px'
}

export default class DndTest extends React.Component {
    render() {
        return (
            <Wrapper>
                <div id='dr1' style={droppableStyle}>
                    <Draggable id='Some Text 1'>Some Text 1</Draggable>
                    <Draggable id='Some Text 2'>Some Text 2</Draggable>
                </div>
                <Droppable id='dr2' style={droppableStyle}>

                </Droppable>
            </Wrapper>
        )
    }
}
